module.exports = __webpack_public_path__ + "img/fundo.d76e9305.jpg";